import { render } from "./ContentMainScreen.vue?vue&type=template&id=3fbd7920&scoped=true"
import script from "./ContentMainScreen.vue?vue&type=script&lang=js"
export * from "./ContentMainScreen.vue?vue&type=script&lang=js"

import "./ContentMainScreen.vue?vue&type=style&index=0&id=3fbd7920&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbd7920"]])

export default __exports__